<template>
  <router-link
    :to="{ name }"
    class="block"
    :class="computedClass"
    @click="$emit('click')"
  >
    {{ label }}
  </router-link>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    mobile: Boolean,
  },
  computed: {
    computedClass() {
      return this.mobile
        ? "text-gray-300 hover:text-white transition"
        : "hover:text-white transition duration-200";
    },
  },
};
</script>
